import * as tslib_1 from "tslib";
import getConsumerMailboxOptions from '../services/getConsumerMailboxOptions';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action } from 'satcheljs/lib/legacy';
export default action('loadConsumerMailboxOptions')(function loadConsumerMailboxOptions() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var options, userConfig;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getConsumerMailboxOptions()];
                case 1:
                    options = _a.sent();
                    if (options) {
                        userConfig = getUserConfiguration();
                        userConfig.SessionSettings.UserProxyAddresses = options.EmailAddresses;
                        userConfig.SessionSettings.NotManagedEmailAddresses = options.NotManagedEmailAddresses;
                    }
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=loadConsumerMailboxOptions.js.map